var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.163 2.07 4.593 5.712c-3.481.87-3.447 5.83.047 6.652l4.532 1.067a.33.33 0 0 0 .312-.089l5.265-5.264a.84.84 0 0 1 1.178 0 .84.84 0 0 1 0 1.177l-5.267 5.267a.33.33 0 0 0-.089.312l1.066 4.528c.822 3.494 5.782 3.528 6.652.047l3.642-14.57c.417-1.674-1.098-3.187-2.768-2.77"
})));
export default SvgSend;